module.exports = __webpack_public_path__ + "static/img/img2.7e2600b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/partnerLogo/img2.png
// module id = pPuE
// module chunks = 1